<div class="max-width:30vw;">
  <h4>Necessary File Checklist</h4>
  @if (neccessaryFileList.length > 0 && neccessaryFileList != undefined) {
    <table class="table table-bordered">
      <tbody>
        @for (file of neccessaryFileList; track file) {
          <tr>
            <td>{{ file.type | uppercase }}</td>
            <td>
              @if (file.existed == true) {
                <h5 class="text-success"><i class="fas fa-check-circle"></i></h5>
              }
              @if (file.existed == false) {
                <h5 class="text-danger"><i class="fas fa-times-circle"></i></h5>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  <hr />
  <h4>Optional File Checklist</h4>
  @if (optionalFileList.length > 0 && optionalFileList != undefined) {
    <table class="table table-bordered">
      <tbody>
        @for (file of optionalFileList; track file) {
          <tr>
            <td>{{ file.type | uppercase }}</td>
            <td>
              @if (file.existed == true) {
                <h5 class="text-success"><i class="fas fa-check-circle"></i></h5>
              }
              @if (file.existed == false) {
                <h5 class="text-danger"><i class="fas fa-times-circle"></i></h5>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
